(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .controller("LearningItemEditCommonInfoModalCtrl", ["$scope", "messageService", "learningItemResource", "gamificationResource", "$translate",
        "learningItem", learningItemEditCommonInfoModalCtrl]);
    function learningItemEditCommonInfoModalCtrl($scope, messageService, learningItemResource, gamificationResource, $translate, learningItem) {
        var vm = this;
        vm.showErrors = false;
        var lang = $translate.proposedLanguage() || $translate.use();
        lang = lang.replace("-", "_");
        vm.tinymceInlineOptions = {
            menubar: false,
            resize: true,
            inline: true,
            height: 200,
            plugins: "code, paste, textcolor, autoresize, link",
            toolbar: "bold italic underline strikethrough superscript subscript | forecolor backcolor | undo bullist numlist | link",
            forced_root_block: false,
            default_link_target: "_blank",
            language: lang,
            setup: function (editor) {
                editor.on("init", function () {
                    // Default classes of tinyMCE are a bit weird
                    // I add my own class on init
                    // this also sets the empty class on the editor on init
                    if (editor.getContent() === "")
                        window.tinymce.DOM.addClass(editor.bodyElement, "content-editor empty");
                    else
                        window.tinymce.DOM.addClass(editor.bodyElement, "content-editor");
                });
                editor.on("focus", function () {
                    window.tinymce.DOM.removeClass(editor.bodyElement, "empty");
                });
                editor.on("blur", function () {
                    if (editor.getContent() === "") {
                        window.tinymce.DOM.addClass(editor.bodyElement, "empty");
                    }
                    else {
                        window.tinymce.DOM.removeClass(editor.bodyElement, "empty");
                    }
                });
            }
        };
        vm.learningItemEdit = learningItem;
        var originalGamificationPoints = learningItem.gamificationPoints;
        vm.setExpiresValidation = function () {
            var years = parseInt(vm.learningItemEdit.expireYears, 10) || 0;
            var months = parseInt(vm.learningItemEdit.expireMonths, 10) || 0;
            var days = parseInt(vm.learningItemEdit.expireDays, 10) || 0;
            if (years + months + days > 0)
                vm.expiresValidation = "expires"; // any value will do
            else
                vm.expiresValidation = "";
        };
        vm.setExpiresValidation();
        vm.updateLearningItem = function (isValid) {
            if (vm.saving)
                return;
            if (isValid) {
                vm.saving = true;
                vm.learningItemEdit.expireYears = vm.learningItemEdit.expireYears === "" ? 0 : parseInt(vm.learningItemEdit.expireYears, 10);
                vm.learningItemEdit.expireMonths = vm.learningItemEdit.expireMonths === "" ? 0 : parseInt(vm.learningItemEdit.expireMonths, 10);
                vm.learningItemEdit.expireDays = vm.learningItemEdit.expireDays === "" ? 0 : parseInt(vm.learningItemEdit.expireDays, 10);
                learningItemResource.update(vm.learningItemEdit, function (result) {
                    vm.learningItem = result;
                    messageService.success("learningItem.updatedSuccessMessage");
                    if (vm.learningItemEdit.gamificationPoints !== originalGamificationPoints)
                        gamificationResource.updateItemCompletionGamificaitonHistoryForAllLearners({ code: vm.learningItemEdit.code, points: vm.learningItemEdit.gamificationPoints }, function () {
                            //nothing
                        }, function (error) {
                            messageService.error(error);
                        });
                    vm.saving = false;
                    $scope.$close(result);
                }, function () {
                    vm.saving = false;
                    messageService.error("common.genericError");
                });
            }
            else {
                vm.showErrors = true;
            }
        };
    }
})();
